import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../local-storage-service/local-storage.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import * as moment from 'moment';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private locale = new BehaviorSubject('');
  private static calendarLocales = {
    en: ['enGb', 'en-gb']
  }

  constructor(
    private translateService: TranslateService,
    private localStorageService: LocalStorageService,
  ) {}



  public initLanguage(): void {
    this.translateService.addLangs(['en', 'de']);
    this.translateService.setDefaultLang('en');
    this.setCurrentLanguage();
    this.subscribeToLanguageChange();
  }

  private setCurrentLanguage(): void {
    const languages = this.translateService.getLangs();
    const localLang = this.localStorageService.getLang();
    if (localLang !== null && languages.includes(localLang)) {
      this.translateService.use(localLang);
      this.locale.next(localLang.toUpperCase());
    } else {
      this.translateService.use('en');
      this.locale.next('EN');
      this.localStorageService.setLang('en');
    }
  }

  private subscribeToLanguageChange(): void {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.locale.next(event.lang.toUpperCase());
    });
  }

  public updateCalendars(language: string, localeService: BsLocaleService): void {
    const lang = LanguageService.calendarLocales[language];
    defineLocale(lang[1], this.locale[`${lang[0]}Locale`]);
    localeService.use(lang[1]);
    moment.locale(language);

  }

  public getLocale(): BehaviorSubject<string> {
    return this.locale;
  }
}
